import { apiPostJSON } from "../client.js";
import { cancelRequest } from "../core/request-coordinator.js";
import { loadSelectedArtifactContent } from "./snapshot.js";

export async function handleTurnDetailClick(state, target, options = {}) {
  if (!(target instanceof Element) || !target.closest("[data-turn-detail-component]")) {
    return false;
  }

  const tabButton = target.closest("[data-tab]");
  if (tabButton) {
    state.activeTab = tabButton.getAttribute("data-tab") || "output";
    options.render?.();
    return true;
  }

  const artifactChoice = target.closest("[data-artifact-id]");
  if (artifactChoice) {
    cancelRequest(state.requests.artifactBody);
    state.selectedArtifactID = artifactChoice.getAttribute("data-artifact-id") || "";
    state.artifactBody = "";
    state.artifactError = "";
    options.render?.();
    return true;
  }

  const loadArtifact = target.closest("[data-action='load-artifact']");
  if (loadArtifact) {
    await loadSelectedArtifactContent(state, options.apiKey, options);
    return true;
  }

  const cancel = target.closest("[data-action='cancel-run']");
  if (cancel && state.turn) {
    options.setStatus?.("Canceling...", "busy");
    const canceled = await apiPostJSON(options.apiKey, `/v1/turns/${encodeURIComponent(state.turn.id)}/cancel`, {});
    await options.refreshCollections?.();
    options.setStatus?.(canceled && canceled.state === "canceled" ? "Turn canceled." : "Cancel requested.", "ok");
    options.render?.();
    return true;
  }

  return false;
}
